import axios from './axios';

interface Options {
  resetEmail: string;
}

export default async function submitForgottenPassword(options: Options): Promise<void> {
  await axios.post('/submit-forgotten-password', options);
}
